import React, { Component } from 'react'
import FlipCounter from '../FlipCounter'
import Swiper from 'react-slider-swiper'
import firebase from 'firebase'
import Lines from '../Lines'
import BubbleButton from '../BubbleButton/BubbleButton'

import './styles/TopSectionStyles.css'



class TopSection extends Component {

    constructor(props) {
        super(props)

        this.state = {
            updateCount: 0,
            startCounter: false,
            data: {},
            items: []
        }


    }

    componentDidMount() {
        const dbRef = firebase.database().ref('sections/topSection')
        const objRef = firebase.database().ref('sections/CompetencySection/items')

        dbRef.on('value', this.setData.bind(this))
        objRef.on('value', this.setObjData.bind(this))
    }

    setObjData(snapshot) {
        const data = snapshot.val()

        if (data) {
            const items = []

            for (let key in data) {
                items.push(data[key])
            }

            this.setState({
                items: items,
                updateCount: parseInt(items[0].metrics, 10)
            })
        }
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {
            this.setState({
                data: data
            })
        }


    }


    renderSlides() {
        if (this.state.items && this.state.items.length > 0) {

            return this.state.items.map((item, i) => {

                return (
                    <div className="TransparentSlide" key={`CounterDecription${i}`}>
                        <div className="CounterDecription">
                            <span className="CounterDecriptionText"><b>{item.descriptor.split(' ')[0] ? item.descriptor.split(' ')[0] : ''}</b> <i>{item.descriptor.split(' ')[1] ? item.descriptor.split(' ')[1] : ''}</i></span>
                        </div>
                    </div>
                )
            })

        }

        return (
            <div className="TransparentSlide" />
        )
    }

    render() {


        return (
            <div style={{ height: window.innerHeight }} className={'TopSectionWrapper'}>
                <div className="TopSectionOverlay" />
                <div className={'TopSlider'}>
                    <div className="TopSectionCounterWrapper">

                        <FlipCounter value={this.state.updateCount} />
                        <div className="QuoteWrapper">
                            <div className={'PartnersTitle'}>{'Успешно сотрудничаем с:'}</div>
                            <div className="QuoteText">{this.state.data.descr ? this.state.data.descr : '-'}</div>
                            <div className="QuoteNameWrapper">
                                <div className="QuoteNameText">
                                    —  {this.state.data.qouteName} (с)
                                </div>
                            </div>

                        </div>
                    </div>
                    {(this.state.items && this.state.items.length > 0) ? (
                        <Swiper
                            pagination={'.TopSectionSliderDots'}
                            paginationClickable={true}
                            onSlideChangeStart={(swiper) => {
                                let e = swiper.activeIndex - 1
                                if (e === this.state.items.length) {
                                    e = 0
                                }
                                if (this.state.items[e]) {
                                    this.setState({ updateCount: parseInt(this.state.items[e].metrics, 10) })
                                }
                            }}
                            autoplay={4000}
                            spaceBetween={30}
                            slidesPerView={1}
                            loop={true}
                        >
                            {this.renderSlides()}
                        </Swiper>
                    ) : null}
                    <div className="BubbleButtonWrapperTop">
                        <BubbleButton type={'orange'} title={'КОНСУЛЬТАЦИЯ'} appRootView={this.props.appRootView} />
                    </div>
                    <div className="BubbleButtonWrapperTopMobile">
                        <BubbleButton type={'orange'} title={'КОНСУЛЬТАЦИЯ'} appRootView={this.props.appRootView} />
                    </div>
                </div>

                <Lines opacity={0.2} />
            </div>
        )
    }
}

export default TopSection


// WEBPACK FOOTER //
// ./src/Components/Sections/TopSection.js